
import './style.scss'
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../redux/hooks';
import { setDataLoadRequestFinished } from '../../redux/reducers/userSlice';
import { setSubPage } from '../../redux/reducers/dashboardSlice';
import { DashboardSubPages } from '../../types/types';
import { adminConnector } from '../../server/connector/adminConnector';
import AdminSideMenu from '../../sections/adminSideMenu/AdminSideMenu';
import AdminContentArea from '../../sections/adminContentArea/AdminContentArea';
import AdminHeader from '../../sections/adminHeader/AdminHeader';
import { adminStateData } from '../../data/adminStateData';
import { PAGE_URLS } from '../../constants/hrefLinks';
import { useCookies } from 'react-cookie';

function Admin() {
	const [cookies] = useCookies()
	const dispatch = useAppDispatch()

	const [adminDataLoaded, setAdminDataLoaded] = useState<boolean>(false)

	useEffect(() => {
		// set subpage for side menu highlighting
		dispatch(setSubPage(DashboardSubPages.MAIN))
		// check if log in has been checked and confirmed in App.tsx
		if (cookies?.adminLogin) {
			adminStateData.loggedIn = cookies?.adminLogin
			loadProfileData()
		} else {
			window.location.replace(PAGE_URLS.ADMIN_LOGIN)
		}
	}, [])

	const loadProfileData = () => {
		if (adminConnector.requestInProgress) {
			console.log('[Dashboard] - loadProfileData() called while requestInProgress')
		} else {
			adminConnector.performGetAdminCustomersRequest().then((requestStatus) => {
				if (!requestStatus) {
					console.log('WARNING - [Admin] - performGetAdminCustomersRequest() failed')
					dispatch(setDataLoadRequestFinished(true))
					setAdminDataLoaded(true)
				}
				else {
					adminConnector.performGetAdminInstructorsRequest().then((requestStatus) => {
						if (!requestStatus) {
							console.log('WARNING - [Admin] - performGetAdminInstructorsRequest() failed')
							dispatch(setDataLoadRequestFinished(true))
							setAdminDataLoaded(true)
						}
						else {
							dispatch(setDataLoadRequestFinished(true))
							setAdminDataLoaded(true)
						}
					})
				}
			})
		}
	}

	return (
		<div className='dashboard-wrap'>
			{adminDataLoaded &&
				<>
					<AdminSideMenu />
					<div
						className='dashboard-content-wrap'
					>
						<AdminHeader title='Admin' />
						<AdminContentArea />
					</div>
				</>
			}
		</div>
	)
}

export default Admin
